import type {UpdateDraftCustomerOfferFormPayload} from "./update-draft-customer-offer.schema";
import {updateDraftCustomerOffer} from "@project/sdk/sales";
import {UpdateDraftCustomerOfferResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../customerOffer-keys";
import {updateDraftCustomerOfferFormSchema} from "./update-draft-customer-offer.schema";

export function updateDraftCustomerOfferMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.updateDraftCustomerOffer,
    mutationFn: async (payload: UpdateDraftCustomerOfferFormPayload) =>
      UpdateDraftCustomerOfferResponse.parse(
        await updateDraftCustomerOffer(id, updateDraftCustomerOfferFormSchema.parse(payload)),
      ),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(id)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
